export const APPLICATION_STEP = {
  NEW: 'NEW',
  VALIDATED: 'VALIDATED',
  // TODO: Remove this after acceptation of featIcAutoValidation
  WAITING_ACCEPTATION: 'WAITING_ACCEPTATION',
  REFUSED: 'REFUSED',
  DOCUMENT: 'DOCUMENT',
  // TODO: Remove this after acceptation of featIcAutoValidation
  WAITING_DOCUMENT_VALIDATION: 'WAITING_DOCUMENT_VALIDATION',
};
